import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import SubmitCCConfirmationModal from '@brands/Dashboard/Dashboard/DashboardModals/SubmitCCConfirmationModal';
import { useAppDispatch } from '@brands/hooks/useReduxHook';
import { getCaseIntake, submitCaseIntake } from '@brands/services/cases/multiStage';
import { clearLinkedCase } from '@brands/store/slices/linkedCaseSlice';
import { displayErrorDetails } from '@brands/Utils/displayError';

// The end of a linked care coordination case's intake: there are no
// questions, only the Jotform link. We have no Jotform integration, so the
// patient seeing this popup is all the case waits on; the empty intake
// submission tells the server so, and it releases the case to be assigned.
const LinkedCareCoordinationForm = (): JSX.Element => {
  const { caseId } = useParams();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(clearLinkedCase());
    const id = Number(caseId);
    if (!id) return;
    // Only a case the server is still holding for this popup is submitted,
    // so reopening an old notification never resubmits.
    getCaseIntake(id)
      .then((intake) => {
        if (intake.is_linked_care_coordination && intake.needs_intake) {
          return submitCaseIntake(id, {});
        }
        return undefined;
      })
      .catch(displayErrorDetails);
  }, [caseId, dispatch]);

  return <SubmitCCConfirmationModal />;
};

export default LinkedCareCoordinationForm;
